// SidebarBucketAddButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './SidebarBucketAddButton.css';

// Components
import Icon from 'svg/Icon';

/**
 * SidebarBucketAddButton
 * 
 * Description
 *  
 * @returns {ReactNode} - SidebarBucketAddButton.
 */
const SidebarBucketAddButton = React.memo(({ label, onClick }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover state
    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <div className="sidebar-bucket-add-button-container"
            style={{
                color: hovered ? theme.foreground : theme.foregroundMuted
            }}
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}>
            <Icon
                iconKey="add"
                width={16}
                height={16}
                color={hovered ? theme.foreground : theme.foregroundMuted}
            />
            {label}
        </div>
    );

});

// Dev Tools
SidebarBucketAddButton.displayName = 'SidebarBucketAddButton';

export default SidebarBucketAddButton;

